(function () {
  const steps = document.querySelector(".jb-steps");
  const wrapperRight = steps.querySelector(".steps__right");
  const wrapperLeft = steps.querySelector(".jb__steps__left");
  // if window resize
  window.addEventListener("resize", () => {
    if (window.innerWidth <= 989) {
      wrapperRight.style.height = "auto";
    } else {
      if (wrapperLeft && wrapperRight) {
        // Use a timeout to ensure elements are fully rendered and have their final heights
        setTimeout(() => {
          // Get wrapper left height
          const wrapperLeftHeight = wrapperLeft.offsetHeight / 1.5;

          // Set wrapper right height to match wrapper left height
          wrapperRight.style.height = `${wrapperLeftHeight}px`;
        }, 300); // Adjust the timeout duration as needed
      } else {
        console.warn("One or both elements are missing:", { wrapperLeft, wrapperRight });
      }
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    if (wrapperLeft && wrapperRight) {
      // Use a timeout to ensure elements are fully rendered and have their final heights
      setTimeout(() => {
        // count element steps__slide-item--desktop
        let slieTotal = steps.querySelectorAll(".steps__slide-item--desktop");
        console.log("Total slide:", slieTotal.length);

        // Get wrapper left height
        const wrapperLeftHeight = wrapperLeft.offsetHeight / 1.3;
        // console.log("Wrapper Left Element:", wrapperLeft);
        // console.log("Wrapper Left Height:", wrapperLeftHeight);

        // Set wrapper right height to match wrapper left height
        wrapperRight.style.height = `${wrapperLeftHeight}px`;
      }, 300); // Adjust the timeout duration as needed
    } else {
      console.warn("One or both elements are missing:", { wrapperLeft, wrapperRight });
    }
  });
  if (window.innerWidth <= 989) {
    wrapperRight.style.height = "auto";
  }

  // Checking if steps element exists before proceeding
  if (steps) {
    const calcDurationScroll = (elem) => {
      switch (elem.length) {
        case 1:
          return "bottom bottom";
        case 2:
          return "+=80%";
        case 3:
          return "+=140%";
        case 4:
          return "+=180%";
        case 5:
          return "+=200%";
        default:
          console.warn("Unexpected number of elements:", elem.length);
          return "bottom bottom";
      }
    };

    let slides = steps.querySelectorAll(".steps__slide-item--desktop");
    let allImage = steps.querySelectorAll(".steps__image");

    let contentWrap = steps.querySelector(".steps__slides");

    let previousScrollY = window.scrollY;

    slides.forEach((elem) => {
      let st = ScrollTrigger.create({
        trigger: elem,
        start: "top 50%",
        end: "bottom 50%",
        // markers: true,
        onEnter: () => {
          // get element data-order
          let order = elem.getAttribute("data-order");

          allImage.forEach((img) => {
            if (img.getAttribute("data-order") == order) {
              img.classList.add("active");
            } else {
              img.classList.remove("active");
            }
          });
        },
        // on enterback
        onEnterBack: () => {
          let order = elem.getAttribute("data-order");

          allImage.forEach((img) => {
            if (img.getAttribute("data-order") == order) {
              img.classList.add("active");
            } else {
              img.classList.remove("active");
            }
          });
        },
      });
    });
  }
})();
